const storageManager = App.es6.shared.storage_manager().init('local');

export function getSearchInteractionsForRoom(key, roomId) {
  let data;
  try {
    const storage = storageManager.get(key) ?? '{}';
    data = JSON.parse(storage);

    let wasSeen = false;
    let wasClicked = false;

    Object.values(data).forEach(({ seen, clicked }) => {
      if (seen.includes(roomId)) {
        wasSeen = true;
      }
      if (clicked.includes(roomId)) {
        wasClicked = true;
      }
    });

    return {
      wasSeen,
      wasClicked,
    };
  } catch (err) {
    console.log(data);
    console.error('Failed getting seen', err);
    Rollbar.error('Failed getting seen', err);
    return {
      wasSeen: false,
      wasClicked: false,
    };
  }
}
